import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=6a16b7fa&scoped=true&lang=pug&"
import script from "./Layout.vue?vue&type=script&lang=js&"
export * from "./Layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a16b7fa",
  null
  
)

export default component.exports